import React, { useEffect, useState } from "react";
import { ServicesTypesComponentLoad } from "../../types/ApplicationTypes";
import AddAnotherServiceUser from "../../components/AddAnotherServiceUser/AddAnotherServiceUser";
import { useServiceUserCreationCtx } from "../../context/ServiceUserCreationContext";
import SomeoneElse from "../../components/CreatePerson/SomeoneElse";
import TrustedContactsForm from "../../components/CreatePerson/Forms/TrustedContactsForm";

function AddandEditProfileContainer() {
  const [clearFields, setClearFields] = useState<boolean>(false);
  const {
    whoWillUseServicesCtx,
    pageTypeCtx,
    relationshipTypesCtx,
    getRelationshipList,
  } = useServiceUserCreationCtx();
  const [pageType, setPageType] = pageTypeCtx;
  const [, setWhoWillUseServices] = whoWillUseServicesCtx;
  const [relationshipTypes] = relationshipTypesCtx;

  useEffect(() => {
    setWhoWillUseServices("Profile");
  }, []);

  useEffect(() => {
    !relationshipTypes && getRelationshipList();
  }, []);

  return <div>{componentSwitch(pageType)}</div>;

  function componentSwitch(pageType: any) {
    switch (pageType) {
      case ServicesTypesComponentLoad.TrustedContacts:
        return <TrustedContactsForm setPageType={setPageType} />;
      case ServicesTypesComponentLoad.DashBoard:
        return (window.location.hash = `/DashBoard`);
      case ServicesTypesComponentLoad.ManageServiceUser:
        return (window.location.hash = `/DashBoard/ManageServiceUsers`);
      case ServicesTypesComponentLoad.AddAnotherServiceUser:
        return (
          <AddAnotherServiceUser
            setPageType={setPageType}
            clearFields={clearFields}
            setClearFields={setClearFields}
          />
        );
      default:
        return <SomeoneElse />;
    }
  }
}
export default AddandEditProfileContainer;
